import React from 'react'
import { message } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'
import { SuperOrderTable } from 'components/orders/SuperOrder/SuperOrderTable'
import { useSuperOrder } from 'components/orders/SuperOrder/useSuperOrder'
import { MainTitle } from 'components/ui/MainTitle/MainTitle'
import { getOrderPath } from 'routing/utils/getOrderPath'
import { superAdminRoutes } from 'shared/constants/routes'

export const SuperOrder: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()

  const { superOrder, isLoading, isMissing, applyStatus } = useSuperOrder(id)

  React.useEffect(() => {
    if (isLoading) {
      message.loading('Загрузка данных')
      return
    }
    message.destroy()
  }, [isLoading])

  React.useEffect(() => {
    if (isMissing) {
      navigate(superAdminRoutes.ORDERS)
    }
  }, [isMissing])

  if (!superOrder) {
    return null
  }

  return (
    <div style={{ paddingBottom: 60 }}>
      <MainTitle
        isGoBack
        text={`Супер-заказ № ${superOrder.number}`}
        style={{ marginBottom: 30 }}
      />
      <SuperOrderTable
        orders={superOrder.orders}
        onOpenOrder={(orderId) => navigate(getOrderPath(orderId))}
        onStatusChange={applyStatus}
      />
    </div>
  )
}
